import projection from '../generated/pwj502f1.json'; import { AcceptanceManifest } from '../types';
export const pwj502f1AcceptanceManifest = projection as AcceptanceManifest;
